<div class="action-definition-router">
	<router-outlet>
	</router-outlet>
</div>